import z from "zod";

export const URLSchema = z.union([z.literal(''), z.string().regex(/^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?$/, 'Invalid URL, please enter a valid URL like: www.example.com')]);
